/* eslint-disable no-use-before-define */
/* eslint-disable camelcase */
import axios from 'axios'
import { useCookies } from 'vue3-cookies'
import { ref } from 'vue'

import { mypageValidity } from './mypage'

const { cookies } = useCookies()

const instance = axios.create({
  baseURL: process.env.VUE_APP_LMS_URL,
})

let getAccess = ''
// eslint-disable-next-line no-unused-vars
let getRefresh = ''
let headers = ''
// eslint-disable-next-line import/prefer-default-export
export async function loadDeliveryMsg() {
  const getDeliverymsg = await instance.get(`/api/v1/pay/delivery/message`)
  // console.log(getDeliverymsg.data)
  return getDeliverymsg.data
}

export async function loadUserDatas() {
  let mypageUrl = ''
  getAccess = cookies.get('access_token')
  getRefresh = cookies.get('refresh_token')
  const accessErr = ref(false)
  try {
    headers = { Authorization: getAccess }
    mypageUrl = await instance.get(`/api/v1/member/my/profile`, { headers })
    const mypageRes = mypageUrl.data
    // console.log('결과값 ::: ', mypageRes)
    // console.log('콘텐츠 ::: ', mypageRes.content)
    return mypageRes
    // return mypageRes.content
  } catch (err) {
    // console.log(err.response.data)
    if (err.response.data.status_code === 401) {
      accessErr.value = true
      return err.response.data
    }
    mypageValidity(err.response.data.status_code)
    const mypageRes = mypageUrl.data
    return mypageRes
  }
}

// eslint-disable-next-line consistent-return
export async function loadDetailContentsOptions(contentsId) {
  try {
    const contentsDetailRes = await instance.get(
      `/api/v1/lecture/intro/contents/${contentsId}`
    )
    // console.log(contentsDetailRes.data.content.option)
    return contentsDetailRes.data.content.option
  } catch (err) {
    // console.log(err.response.data)
    return err.response.data
  }
}

// eslint-disable-next-line consistent-return
export async function loadOrderDatas(page) {
  getAccess = cookies.get('access_token')
  getRefresh = cookies.get('refresh_token')

  const pageStart = 1
  const pageSize = 5
  let orderListRes = ''
  try {
    headers = { Authorization: getAccess }
    if (page == null) {
      orderListRes = await instance.get(
        `api/v1/member/my/order?page_index=${pageStart}&page_size=${pageSize}`,
        { headers }
      )
      // console.log(orderListRes.data)
    } else {
      orderListRes = await instance.get(
        `api/v1/member/my/order?page_index=${page}&page_size=${pageSize}`,
        { headers }
      )
      // console.log(orderListRes)
    }
    return orderListRes.data
  } catch (err) {
    // if (err.response.data.status_code === 401) {
    //   return err.response.data.status_code
    // }
    // mypageValidity(err.response.data.status_code)
  }
}

// eslint-disable-next-line consistent-return
export async function loadOrderDetailData(orderNo) {
  getAccess = cookies.get('access_token')
  getRefresh = cookies.get('refresh_token')
  try {
    headers = { Authorization: getAccess }
    const orderDetailRes = await instance.get(
      `/api/v1/member/my/order/${orderNo}`,
      { headers }
    )
    // console.log(orderDetailRes)
    return orderDetailRes.data
  } catch (err) {
    console.log(err)
  }
}

export async function loadCancelReason() {
  getAccess = cookies.get('access_token')
  getRefresh = cookies.get('refresh_token')
  try {
    headers = { Authorization: getAccess }
    const reasonRes = await instance.get(
      `/api/v1/member/my/order/cancel/reason`,
      { headers }
    )
    console.log(reasonRes)
    console.log(reasonRes.data)
    return reasonRes.data
  } catch (err) {
    console.log(err)
    console.log(err.response.data)
    return err.response.data
  }
}

export async function sendCancelReason(
  selectedOrderNo,
  selectedCode,
  enterreason
) {
  getAccess = cookies.get('access_token')
  getRefresh = cookies.get('refresh_token')
  console.log(enterreason)
  try {
    if (selectedCode !== '111199') {
      headers = { Authorization: getAccess }

      const data = { code: selectedCode }
      const reqRefundRes = await instance.post(
        `/api/v1/member/my/order/${selectedOrderNo}/cancel`,
        data,
        { headers }
      )
      // console.log(reqRefundRes)
      return reqRefundRes.data
      // eslint-disable-next-line no-else-return
    } else {
      headers = { Authorization: getAccess }

      const datas = { code: selectedCode, reason: enterreason }
      const reqRefundRes = await instance.post(
        `/api/v1/member/my/order/${selectedOrderNo}/cancel`,
        datas,
        { headers }
      )
      console.log(reqRefundRes)
      return reqRefundRes.data
    }
  } catch (err) {
    console.log(err)
    return err.response.data
  }
}
